import { observable, reaction } from 'mobx';

type Settings = {
  hideOfflineDevices: boolean;
};
export const GlobalSettingsStore = observable.box(getSettingsFromStorage());

function getSettingsFromStorage(): Settings {
  const hideOfflineDevices = localStorage.getItem('hideOfflineDevices') === 'true';
  return {
    hideOfflineDevices,
  };
}

function saveSettingsToLocalStorage(settings: Settings) {
  localStorage.setItem('hideOfflineDevices', settings.hideOfflineDevices ? 'true' : 'false');
}

reaction(
  () => GlobalSettingsStore.get(),
  (settings) => saveSettingsToLocalStorage(settings),
);
